import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const load = () => api.get("/admin/announcements").then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try { await api.post("/admin/announcements", { text, active: true }); setText(""); load(); toast.success("Created"); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  const del = async (id) => { try { await api.delete(`/admin/announcements/${id}`); load(); } catch (e) { toast.error(errorMessage(e)); } };

  return (
    <div data-testid="admin-announcements">
      <h1 className="font-display font-extrabold text-3xl md:text-4xl">Announcements</h1>
      <p className="text-gray-500 mt-1 text-sm mb-6">Active announcements show as a banner across the site.</p>

      <form onSubmit={create} className="bg-white border border-gray-100 rounded-2xl p-5 mb-6 flex gap-3">
        <input className="input-base flex-1" value={text} onChange={e => setText(e.target.value)} placeholder="e.g. Orders Close Thursday at 8 PM" data-testid="announcement-input" />
        <button type="submit" className="btn-pink !py-2 !px-5 text-sm" data-testid="announcement-create-btn">CREATE</button>
      </form>

      <ul className="space-y-2">
        {items.map(a => (
          <li key={a.id} className="bg-white border border-gray-100 rounded-2xl p-4 flex items-center justify-between" data-testid={`announcement-${a.id}`}>
            <div>
              <p className="font-bold">{a.text}</p>
              <p className="text-xs text-gray-500">{new Date(a.created_at).toLocaleString()} · {a.active ? "Active" : "Inactive"}</p>
            </div>
            <button onClick={() => del(a.id)} className="text-red-500 hover:text-red-700 p-2"><Trash2 className="w-4 h-4" /></button>
          </li>
        ))}
        {items.length === 0 && <li className="text-gray-500 text-sm">No announcements yet.</li>}
      </ul>
    </div>
  );
}
